if (!customElements.get('collection-hero-description')) {
  customElements.define(
    'collection-hero-description',
    class CollectionHeroDescription extends HTMLElement {
      connectedCallback() {
        this.text = this.querySelector('[data-collection-description-text]');
        this.toggle = this.querySelector('[data-collection-description-toggle]');
        this.moreLabel = this.querySelector('[data-collection-description-more]');
        this.lessLabel = this.querySelector('[data-collection-description-less]');

        if (!this.text || !this.toggle) return;

        this.handleResize = () => {
          if (!this.classList.contains('is-expanded')) this.updateOverflow();
        };

        requestAnimationFrame(() => this.updateOverflow());
        document.fonts?.ready.then(() => this.updateOverflow());
        this.toggle.addEventListener('click', () => this.toggleDescription());
        window.addEventListener('resize', this.handleResize);
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.handleResize);
      }

      updateOverflow() {
        const hasOverflow = this.text.scrollHeight > this.text.clientHeight + 1;
        this.toggle.hidden = !hasOverflow;
      }

      toggleDescription() {
        const expanded = this.classList.toggle('is-expanded');

        this.toggle.setAttribute('aria-expanded', expanded.toString());
        this.moreLabel.hidden = expanded;
        this.lessLabel.hidden = !expanded;
      }
    }
  );
}
